import { DATA_FIELDS, TYPE_OF_USE_VALUES } from 'store/insurance/constants';

export const NAME = DATA_FIELDS.TYPE_OF_USE;

export const LIST = [
  { id: TYPE_OF_USE_VALUES.PERSONAL, title: 'Личная' },
  { id: TYPE_OF_USE_VALUES.TAXI, title: 'Такси' },
  { id: TYPE_OF_USE_VALUES.COMMERCIAL, title: 'В иных коммерческих целях' },
];
